export default "__VITE_ASSET__BxCzJqL$__"